export default "__VITE_ASSET__TB7NZ_25__"